/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S4_BodyInputs */

const en_landing_guide_s4_body = /** @type {(inputs: Landing_Guide_S4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the brief like a designer would: subject first, then composition, light and mood. Put every word that must appear in the image inside quotes, and keep that text short. For edits, describe only the change ("make the cup a glass of orange juice") rather than the whole scene, and paint slightly beyond the object so the model has room to blend. Use the High mode for finals with fine type or detailed textures, and the standard mode for exploring ideas quickly.`)
};

const zh_landing_guide_s4_body = /** @type {(inputs: Landing_Guide_S4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`像设计师写需求一样写提示词：先写主体，再写构图、光线和氛围。所有需要出现在画面中的文字都放进引号，并尽量简短。编辑时只描述改动本身（例如“把杯子换成一杯橙汁”），不要重写整个场景；涂抹范围略大于目标物体，给模型留出融合空间。需要精细文字或丰富纹理的定稿用 Ideogram 4.5 High，快速探索创意用标准模式。`)
};

/**
* | output |
* | --- |
* | "Write the brief like a designer would: subject first, then composition, light and mood. Put every word that must appear in the image inside quotes, and keep ..." |
*
* @param {Landing_Guide_S4_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s4_body = /** @type {((inputs?: Landing_Guide_S4_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S4_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s4_body(inputs)
	return zh_landing_guide_s4_body(inputs)
});
export { landing_guide_s4_body as "landing.guide.s4_body" }